import PageModule from "@eisinc/Overrides/Pages/Footer";

export * from "@eisinc/Overrides/Pages/Footer";

export default PageModule;
